<template>
    <section class="main">
        <div class="container">
            <div class="inner-mobile-description">
                <div class="row mobile-reverse">
                    <div class="col-md-6 left-image">
                        <img src="../assets/img/features/mobile-photo.png" alt="">
                    </div>
                    <div class="col-md-6">
                        <div class="first-mobile">
                            <p>Money's a team game</p>
                            <h1>Don't be a 
                                grich, set  goals and  <span>save with  your friends</span>
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="first-mobile second-block">
                            <p>Goal based savings!</p>
                            <h1>Dreaming of a flight to London or a beach wedding in Bali, just <span> set a goal and save.</span>
                            </h1>
                        </div>
                    </div>
                    <div class="col-md-6 left-image">
                        <img src="../assets/img/features/mobile-photo2.png" alt="">
                    </div>
                </div>
                <div class="row mobile-reverse">
                    <div class="col-md-6 left-image">
                        <img src="../assets/img/features/mobile-photo3.png" alt="">
                    </div>
                    <div class="col-md-6">
                        <div class="first-mobile third-block">
                            <p>Why type when you can scan?</p>
                            <h1><span>Scan a receipt </span> to record the expense. Easy, no more tedious typing. 
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ChartCircleTwo from '../components/ChartCircleTwo'
    import ThreeStepProcess from '../components/ThreeStepProcess'
    import AppShowcaseProcessStep from '../components/AppShowcaseProcessStep'
    export default{
        name: 'ThreeStepProcessWrap',
        components: {
            ChartCircleTwo,
            ThreeStepProcess,
            AppShowcaseProcessStep
        }
    };
</script>

<style lang="scss">

</style>